// extracted by mini-css-extract-plugin
export default {"errorBoundary":"ErrorBoundaryFallback_errorBoundary__Vy+QJ"};